import { useAxiosClient } from '..';

export const useCountryApi = () => {
    const { axiosClient } = useAxiosClient();

    return {
        countryList: async () => (await axiosClient.get(`/v1/country`)).data,
        stateList: async (countryId) => (await axiosClient.get(`/v1/country/${countryId}/states`)).data,
    }
}